import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss';
import ExperimentsData from './ExperimentsData';

interface StatusContainerProps {
  header: React.ReactNode;
  detailsComponent?: React.ReactNode;
  tableComponent?: React.ReactNode;
  experimentsData?: string | null;
}

const StatusContainer = ({
  header,
  detailsComponent,
  tableComponent,
  experimentsData = null
}: StatusContainerProps) => {
  const showDetails = detailsComponent || tableComponent;

  return (
    <div className={cx('w-full h-full ml-3 mb-6', styles.containerBorder)}>
      <div className={cx(styles.headerContainer, showDetails ? '' : 'rounded-[7px]')}>{header}</div>
      {showDetails ? (
        <div className={styles.mockAllocationDetailsContainer}>
          {detailsComponent ? detailsComponent : null}
          {tableComponent ? tableComponent : null}
          {experimentsData ? <ExperimentsData experimentsData={experimentsData} /> : null}
        </div>
      ) : null}
    </div>
  );
};

export default StatusContainer;
